import React, { Component } from "react";
import { Form, Col, Button, ButtonToolbar, Spinner } from "react-bootstrap";
import { inventoryTargetSettingsBranchValidationRules } from "../../../../helpers/validationRules";
import { Formik } from "formik";
import AsyncSelect from "react-select/async";

import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import { GetBranchByCode } from "../../../../store/actions/crdm_service_actions";
import { connect } from "react-redux";

class ManageInventoryTargetBranch extends Component {
  state = {
    areaList: [],
    id: null,
    branchCode: null,
    year: null,
    month: null,
    targetPiece: null,
    targetPrincipal: null,
    isMonthPickerVisible: false,
    isYearPickerVisible: false,
    isLoading: false,
  };

  componentDidMount() {
    if (this.props.mode === "Edit") {
      this.setState({
        isLoading: true,
      });
      this.PremiseGetBranchByCode(this.props.data.branchCode).then((resp) => {
        if (resp.problem === null) {
          var response = {
            label: `(${resp.data.branchCode}) ${resp.data.branchName}`,
            value: resp.data.branchCode,
          };
          this.setState({ branchCode: response });
          return response;
        } else {
          return {};
        }
      });
    }
  }

  pushSubmit = (values, actions) => {
    if (this.props.mode === "Add") {
      this.props.add({
        branchCode: this.state.branchCode.value,
        year: values.year,
        month: values.month,
        targetPiece: values.targetPiece,
        targetPrincipal: values.targetPrincipal,
      });
    } else {
      this.props.edit({
        id: this.props.data.id,
        branchCode: this.state.branchCode.value,
        year: values.year,
        month: values.month,
        targetPiece: values.targetPiece,
        targetPrincipal: values.targetPrincipal,
      });
    }
  };

  PremiseGetBranchByCode = (code) => {
    return this.props.GetBranchByCode(code).then((r) => {
      this.setState({ isLoading: false });
      return Promise.resolve(r);
    });
  };
  loadOptions = (inputValue, callback) => {
    // do some work

    if (inputValue.length >= 3) {
      this.PremiseGetBranchByCode(inputValue).then((resp) => {
        return resp.problem === null
          ? callback([
              {
                label: `(${resp.data.branchCode}) ${resp.data.branchName}`,
                value: resp.data.branchCode,
              },
            ])
          : callback([]);
      });
    } else {
      return callback([]);
    }
  };

  renderFilterView = () => {
    switch (this.state.toView) {
      case "clusters":
        return this.renderClusters();

      case "areas":
        return this.renderAreas();

      case "branches":
        return this.renderBranches();

      default:
        return "";
    }
  };

  handlebranchCode = (fieldData) => {
    this.setState({ branchCode: fieldData });
  };

  render() {
    return (
      <Formik
        onSubmit={(values, actions) => {
          setTimeout(() => {
            this.pushSubmit(values, actions);
          }, 2000);
        }}
        validationSchema={inventoryTargetSettingsBranchValidationRules}
        initialValues={
          this.props.mode === "Add"
            ? {
                branchCode: this.state.branchCode,
                year: this.state.year,
                month: this.state.month,
                targetPiece: this.state.targetPiece,
                targetPrincipal: this.state.targetPrincipal,
              }
            : {
                id: this.props.data.id,
                branchCode: this.props.data.branchCode.value,
                year: this.props.data.year,
                month: this.props.data.month,
                targetPiece: this.props.data.totalPieces,
                targetPrincipal: this.props.data.totalPrincipal,
              }
        }
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => {
          return this.state.isLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Form className="p-3 rounded" noValidate onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} controlId="areaCode">
                  <Form.Label>Branch Code</Form.Label>
                  <AsyncSelect
                    isMulti={false}
                    placeholder="Enter Branch Code"
                    cacheOptions
                    defaultOptions
                    value={this.state.branchCode}
                    onChange={(e) => {
                      setFieldValue("branchCode", e);
                      this.handlebranchCode(e);
                    }}
                    loadOptions={this.loadOptions}
                  />
                  {/* <Form.Control
                    onBlur={handleBlur}
                    onChange={handleChange}
                    isValid={touched.areaCode && !errors.areaCode}
                    isInvalid={touched.areaCode && !!errors.areaCode}
                    value={values.areaCode}
                    as="select"
                  >
                    {this.state.areaList.map((area, idx) => {
                      return (
                        <option
                          key={idx}
                          value={area.peppCode}
                        >{`${area.name} (${area.peppCode})`}</option>
                      );
                    })}
                  </Form.Control> */}
                  <Form.Control.Feedback type="invalid">
                    {errors.areaCode}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="year">
                  <Form.Label>Year</Form.Label>
                  <DatePicker
                    autoOk
                    TextFieldComponent={() => {
                      return (
                        <Form.Control
                          onBlur={handleBlur}
                          onChange={handleChange}
                          onClick={() => {
                            this.setState({ isYearPickerVisible: true });
                          }}
                          value={values.year}
                          isValid={touched.year && !errors.year}
                          isInvalid={touched.year && !!errors.year}
                          type="text"
                          placeholder="Enter year"
                        />
                      );
                    }}
                    disableToolbar
                    open={this.state.isYearPickerVisible}
                    onClose={() =>
                      this.setState({
                        isMonthPickerVisible: false,
                      })
                    }
                    onChange={(e) => {
                      var value = new Date(e);
                      var year = value.getFullYear();
                      this.setState({
                        isYearPickerVisible: false,
                        year: year,
                      });
                      setFieldValue("year", year);
                    }}
                    variant="dialog"
                    views={["year"]}
                    format="YYYY"
                  />

                  <Form.Control.Feedback type="invalid">
                    {errors.year}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Month</Form.Label>
                  <DatePicker
                    autoOk
                    TextFieldComponent={() => {
                      return (
                        <Form.Control
                          name="month"
                          id="month"
                          onClick={() => {
                            this.setState({ isMonthPickerVisible: true });
                          }}
                          type="text"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={
                            values.month
                              ? moment(
                                  new Date(2000, values.month - 1, 1)
                                ).format("MMMM")
                              : null
                          }
                          isValid={touched.month && !errors.month}
                          isInvalid={touched.month && !!errors.month}
                          placeholder="Enter month"
                        />
                      );
                    }}
                    defaultValue={values.month}
                    value={
                      values.month
                        ? moment(new Date(2000, values.month - 1, 1)).format(
                            "MMMM"
                          )
                        : null
                    }
                    disableToolbar
                    open={this.state.isMonthPickerVisible}
                    onClose={() =>
                      this.setState({
                        isMonthPickerVisible: false,
                      })
                    }
                    onChange={(e) => {
                      var value = new Date(e);
                      var month = value.getMonth() + 1;
                      setFieldValue("month", month);
                      this.setState({
                        isMonthPickerVisible: false,
                      });
                    }}
                    variant="dialog"
                    hidden={true}
                    views={["month"]}
                    format="MMMM"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.month}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Form.Group as={Col} controlId="targetPiece">
                  <Form.Label>Piece</Form.Label>
                  <Form.Control
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.targetPiece}
                    isValid={touched.targetPiece && !errors.targetPiece}
                    isInvalid={touched.targetPiece && !!errors.targetPiece}
                    type="number"
                    placeholder="Enter value"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.targetPiece}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col} controlId="targetPrincipal">
                  <Form.Label>Principal</Form.Label>
                  <Form.Control
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.targetPrincipal}
                    isValid={touched.targetPrincipal && !errors.targetPrincipal}
                    isInvalid={
                      touched.targetPrincipal && !!errors.targetPrincipal
                    }
                    type="number"
                    placeholder="Enter value"
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.targetPrincipal}
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Row>

              <ButtonToolbar className="float-right">
                <Button disabled={isSubmitting} type="submit">
                  {isSubmitting ? (
                    <Spinner
                      as="span"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      animation="border"
                    />
                  ) : this.props.mode === "Edit" ? (
                    "Save"
                  ) : (
                    "Create"
                  )}
                </Button>
              </ButtonToolbar>
            </Form>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  GetBranchByCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageInventoryTargetBranch);
